const getClientAltText = state => state.client.altText;

export default getClientAltText;
